var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#9840ef}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.6,9.7H23.9c-0.5,0-1,0.2-1.4,0.6l-8.5,8.5c-0.4,0.4-0.6,0.8-0.6,1.4v33.7c0,1.1,0.9,1.9,1.9,1.9H26v8.7 c0,0.8,1,1.3,1.6,0.7l9.3-9.3h6.5c0.5,0,1-0.2,1.4-0.6L60.9,39c0.4-0.4,0.6-0.8,0.6-1.4V11.6C61.5,10.5,60.6,9.7,59.6,9.7z M59.9,36.5c0,0.9-0.3,1.7-0.9,2.3l-5.8,5.8c-0.6,0.6-1.4,0.9-2.3,0.9h-7.6l-6.1,6.1c-0.5,0.5-1.2,0.8-2,0.8 c-1.6,0-2.8-1.3-2.8-2.8v-4.1H26c-1.8,0-3.2-1.5-3.2-3.2V14.5c0-1.8,1.5-3.2,3.2-3.2h30.7c1.8,0,3.2,1.5,3.2,3.2V36.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,13.5H26c-0.5,0-1,0.4-1,1v27.8c0,0.5,0.4,1,1,1h8.6v6.3c0,0.5,0.6,0.7,1,0.4l6.7-6.7h8.6 c0.3,0,0.5-0.1,0.7-0.3l5.8-5.8c0.2-0.2,0.3-0.4,0.3-0.7v-22C57.6,13.9,57.2,13.5,56.7,13.5z M40.4,31.5c0,0.1-0.1,0.2-0.2,0.2 h-3.4c-0.1,0-0.2-0.1-0.2-0.2V20.5c0-0.1,0.1-0.2,0.2-0.2h3.4c0.1,0,0.2,0.1,0.2,0.2V31.5z M51.9,31.5c0,0.1-0.1,0.2-0.2,0.2h-3.4 c-0.1,0-0.2-0.1-0.2-0.2V20.5c0-0.1,0.1-0.2,0.2-0.2h3.4c0.1,0,0.2,0.1,0.2,0.2V31.5z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.fddd5f0ebe767879c5d44e840a69034e.svg";
export { ForwardRef as ReactComponent };